import { RootReducer } from "../../reducers";

export const stationCalendarSelector = (
    state: RootReducer
): StationCalendarMap => {
    return state.calendar.stationCalendarResponse ?? {};
}